export default __webpack_public_path__ + "static/team-lockers-9c9569ed678175d2e086846cd31d9d2a.jpg";